export * from './dom';
export * from './url';
export * from './entity';
export * from './time';
export * from './property';
export * from './common';
export * from './htmlEscape';
export * from './analytic';
export * as data from './data';
export { default as httpRequest } from './request';
export { default as timezonesOptions } from './data/timezones';

export const zipRegex = {
  us: /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/,
  ca: /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/,
};

export const removeWordEnding = (w: string) => `${w.slice(0, -1)}`;

export const arrayMove = (list: any[], fromIndex: number, toIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(fromIndex, 1);
  result.splice(toIndex, 0, removed);

  return result;
};

/*
 * Get namespace symbol from url
 * app.gymcloud.com => gymcloud
 * custom.app.gymcloud.com => custom
 * strongfirst.gymcloud.com => strongfirst
 * app.strongfirst.com => strongfirst
 */
export const getNamespaceSymbol = (): string => {
  const DEFAULT_NAMESPACE = 'gymcloud'

  // In non-production environments, use localStorage override if available
  if (process.env.TARGET_ENV !== 'production') {
    return window.localStorage.getItem('namespace') || DEFAULT_NAMESPACE
  }

  const { host } = window.location
  const hostParts = host.split('.')

  // Handle different URL patterns:
  // - app.gymcloud.com -> gymcloud (use default)
  // - custom.gymcloud.com -> custom (use subdomain)
  // - custom.app.gymcloud.com -> custom (use first subdomain)
  // - app.strongfirst.com -> strongfirst (use domain name)

  if (hostParts.length === 3) {
    // Format: [subdomain].[domain].com
    const subdomain = hostParts[0]
    const domain = hostParts[1]

    if (domain === 'gymcloud') {
      // For gymcloud domains, 'app' subdomain means use default namespace
      return subdomain === 'app' ? DEFAULT_NAMESPACE : subdomain
    } else {
      // For other domains (like strongfirst.com), use the domain name as namespace
      return domain
    }
  }

  if (hostParts.length === 4) {
    // Format: [namespace].[app].[domain].com
    return hostParts[0]
  }

  // Fallback for unexpected formats
  return DEFAULT_NAMESPACE
}
